<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="1200"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card v-if="supplySelected">
                <v-card-title>
                    <span>{{ supplySelected.name }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pl-0 pr-0">
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-simple-table dense class="table-kardex" height="68vh">
                                    <thead class="debt-header-payment table-kardex-head">
                                        <tr>
                                            <th class="text-left text-uppercase" rowspan="2">Fecha</th>
                                            <th class="text-left text-uppercase column-hora" rowspan="2">Hora</th>
                                            <th class="text-left text-uppercase column-tipo-movimiento" rowspan="2">Tip. Movimiento</th>
                                            <th class="text-left text-uppercase" rowspan="2">Movimiento</th>
                                            <th class="text-left text-uppercase column-tipo-documento" rowspan="2">Tipo Doc.</th>
                                            <th class="text-left text-uppercase" rowspan="2">Serie</th>
                                            <th class="text-left text-uppercase" rowspan="2">Número</th>
                                            <th class="text-center text-uppercase" colspan="3">Entrada</th>
                                            <th class="text-center text-uppercase" colspan="3">Salida</th>
                                            <th class="text-center text-uppercase" colspan="3">Existencias</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center text-uppercase">Cant.</th>
                                            <th class="text-center text-uppercase">Costo</th>
                                            <th class="text-center text-uppercase">Total</th>

                                            <th class="text-center text-uppercase">Cant.</th>
                                            <th class="text-center text-uppercase">Costo</th>
                                            <th class="text-center text-uppercase">Total</th>

                                            <th class="text-center text-uppercase">Cant.</th>
                                            <th class="text-center text-uppercase">Costo</th>
                                            <th class="text-center text-uppercase">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-kardex-body">
                                        <tr v-for="kardex in kardexSupply" :key="kardex.id">
                                            <td>{{ kardex.operation_date  | moment("DD/MM/YYYY") }}</td>
                                            <td>{{ kardex.operation_date  | moment("hh:mm a") }}</td>
                                            <td>{{ kardex.type }}</td>
                                            <td>{{ kardex.sub_type }}</td>
                                            <td>{{ kardex.type_document }}</td>
                                            <td>{{ kardex.serie }}</td>
                                            <td>{{ kardex.correlative }}</td>
                                            <td>
                                                <span class="cantidad-ingreso" v-if="kardex.type == 'INGRESO'">
                                                    {{ kardex.quantity }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="kardex.type == 'INGRESO'">
                                                    {{ kardex.cost | currency('') }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="kardex.type == 'INGRESO'">
                                                    {{ kardex.total | currency('') }}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="cantidad-salida" v-if="kardex.type == 'SALIDA'">
                                                    {{ kardex.quantity }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="kardex.type == 'SALIDA'">
                                                    {{ kardex.cost | currency('') }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="kardex.type == 'SALIDA'">
                                                    {{ kardex.total | currency('') }}
                                                </span>
                                            </td>
                                            <td>{{ kardex.stock }}</td>
                                            <td>{{ kardex.cost | currency('') }}</td>
                                            <td>{{ (kardex.stock * kardex.cost) | currency('') }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'Kardex',
    computed: {
        ...mapState('production', [
            'supplies',
            'supplySelected',
            'kardexSupply'
        ])
    },
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
        }
    },
    methods:{
        showForm(title) {
            this.titleForm = title
            this.drawer = !this.drawer
        },
    }
}
</script>

<style>
.cantidad-ingreso{
    color: #ffffff;
    background-color: #43A047;
    border-radius: 3px;
    width: 50px !important;
    display: block;
    padding-left: 3px;
}

.cantidad-salida{
    color: #ffffff;
    background-color: #E53935;
    border-radius: 3px;
    width: 50px !important;
    display: block;
    padding-left: 3px;
}

.column-hora{
    width: 100px !important;
    min-width: 100px !important;
}

.column-tipo-movimiento{
    width: 150px !important;
    min-width: 150px !important;
}

.column-tipo-documento{
    width: 150px !important;
    min-width: 150px !important;
}

.table-kardex > .v-data-table__wrapper > table > thead > tr > th{
    font-size: 12px !important;
    font-weight: 500 !important;
    height: 30px !important;
}

.table-kardex > .v-data-table__wrapper > table > tbody > tr > td{
    font-size: 12px !important;
    height: 30px;
}

</style>